
//@ts-ignore
import {Action, Nullable} from "@customTypes/CustomUtilityTypes";
//@ts-ignore
import {SnackbarTypes} from "@customTypes/SnackbarTypes";
import {defineComponent} from "vue";

export default defineComponent({
    name: "BaseSnackbar",
    props: {
        type: {type: String as () => SnackbarTypes, default: ""},
        title: {type: String, required: true},
        body: {type: String, required: true},
        icon: {type: Object as () => { src: string; alt: string }},
        timeout: {type: Number, default: 5000},
        cb: {type: Function, default: null}
    },
    emits: ["snackbar-hidden"],
    data() {
        return {
            onSnackbarClick: null as Nullable<Action>
        }
    },
    computed: {
        cdn(): string {
            return window["_cdn"]
        }
    },
    created() {
        /* If present, we will sync the cb with the handler */
        if (this.cb)
            this.onSnackbarClick = this.cb as Nullable<Action>;

        setTimeout(() => {
            /* auto closing */
            this.handleSnackbarClose();
        }, this.timeout)
    },
    methods: {
        handleSnackbarClick() {
            this.onSnackbarClick && this.onSnackbarClick();
        },
        handleSnackbarClose() {
            const snackbarEl = (this.$refs.snackbar as HTMLDivElement);
            /* The snackbar could be null when we manually close it and the callback tries to perform the same action.
            * In that scenario the ordering and state are the following:
            * 0) On created a timer is initialized which will retrieve the snackbar element and add the snackbar-hidden class
            * 1) User clicks on 'X' button to close the snackbar
            * 2) handleSnackbarClose function is called before the callback function triggers
            *   2.1) the handleSnackbarClose function emits the event snackbar-hidden which will destroy the BaseSnackbar component (and all its content)
            * 3) The BaseSnackbar does not exist anymore
            * 4) The callback is triggered but the snackbar element is not present in our DOM, so, an exception will be thrown if the snackbar element is null
            * */
            if (!snackbarEl)
                return;

            snackbarEl.classList.remove("snackbar-active");
            snackbarEl.classList.add("snackbar-hidden");
            setTimeout(() => {
                this.$emit("snackbar-hidden");
            }, 300)
        },
    }
})
